import { render, staticRenderFns } from "./Bailes.vue?vue&type=template&id=5b38702b&"
import script from "./Bailes.vue?vue&type=script&lang=js&"
export * from "./Bailes.vue?vue&type=script&lang=js&"
import style0 from "./Bailes.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports